export const environment = {
	production: true,
	instrumentationKey: "2a5b9b1e-865a-48be-ae65-4094aa6b0c2a",
};
